/**
 * ダイナミック帳票で取り込み項目＝ありの場合に設定される取り込み項目の数
 */
export const GRID_VARIABLES_COUNT = 6
